<template>
  <Card :class="$style.container">
    <div
      :class="$style.blockContainer"
      data-test-id="HomeWelcomeSection__blockContainer"
    >
      <div>
        <HeadingLarge v-if="user.firstname">
          Welcome, {{ user.firstname }}!
        </HeadingLarge>
        <HeadingLarge v-else>
          Welcome !
        </HeadingLarge>
      </div>
      <div
        :class="$style.inlineRight"
      >
        <IconButton
          v-if="showValueReport"
          :class="$style.usageIcon"
          hasNoBackground
          icon="file"
          text="Usage Value Summary"
          @click="handleLinkClick"
        />
        <IconButton
          v-if="!isAnMsp"
          :class="$style.settingsIcon"
          hasNoBackground
          icon="settings"
          text="Customize Home"
          @click="handleRedirect('settings')"
        />
      </div>
    </div>
    <div :class="$style.body">
      <HomeBirdsEyeWidget v-if="showBirdsEyeWidget" />
    </div>
  </Card>
</template>
<script>
import {
  Card,
  HeadingLarge,
  IconButton,
} from '@jumpcloud/ui-components';

import {
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapState } from 'vuex';
import FundamentalsVisibilityMixin from 'client/components/mixins/fundamentalsVisibilityMixin';
import HomeBirdsEyeWidget from 'client/HomePageV2/widgets/HomeBirdsEyeWidget.vue';
import MspState from 'client/components/models/MspState';
import OptimizelyHelper from 'client/GrowthEngineering/OptimizelyHelper';
import SegmentEventMixin from 'client/HomePageV2/mixins/SegmentEventMixin';
import SetActiveFFMixin from 'client/HomePageV2/mixins/SetActiveFFMixin';
import Util from 'client/util/Util';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'HomeWelcomeSection',

  components: {
    Card,
    HomeBirdsEyeWidget,
    HeadingLarge,
    IconButton,
  },

  mixins: [FundamentalsVisibilityMixin, SegmentEventMixin, SetActiveFFMixin],

  OptimizelyHelper,

  data() {
    return {
      settingsRoute: ItemTypeRoutes[ItemTypeConsts.settingsHome],
    };
  },

  computed: {
    ...mapState(settingsModule, [
      'user',
      'isCustomer',
    ]),

    isAnMsp() {
      return MspState.isAnMsp;
    },

    showBirdsEyeWidget() {
      return !this.orgCreatedUnderThirtyDaysAgo;
    },

    showValueReport() {
      const valueReport = this.$hasFeatureFlag(this.$featureFlags.valueReport);
      return valueReport && this.isCustomer && !this.isAnMsp;
    },

    valueReportRoute() {
      return ItemTypeRoutes[ItemTypeConsts.valueReport];
    },
  },

  methods: {
    handleLinkClick() {
      this.triggerWelcomeLinkClickedHandler();
      Util.redirect(ItemTypeRoutes[ItemTypeConsts.valueReport]);
    },

    handleRedirect(icon) {
      const url = this.settingsRoute;
      this.triggerIconClickedHandler(icon, url);
      Util.redirect(url);
    },
  },
};
</script>

<style module scoped>
.container {
  overflow: visible;
  padding-top: 5rem;
}

.body {
  padding-top: var(--jc-spacer-x-small);
}

.settingsButton {
  font-weight: bold;
  text-align: right;
}

.blockContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.inline {
  display: inline-block;
}

.inlineRight {
  display: inline-block;
}

.settingsIcon:not(.legacyOverride):not(.legacyOverride) {
  color: var(--jc-button-informational);
}

.usageIcon:not(.legacyOverride):not(.legacyOverride) {
  color: var(--jc-button-informational);
  margin-right: var(--jc-spacer-small);
}
</style>
